<template>
  <div>
    <b-table striped hover :items="advertisings" :fields="fields">
      <template slot="_id" slot-scope="data">
        <a :href="'/admin/advertisements/' + data.value">{{ data.value }}</a>
      </template>
      <template slot="advertisment" slot-scope="data">
        <ul>
          <li><strong>Title:</strong>&nbsp;{{ data.value.title }}</li>
          <li><strong>Text:</strong>&nbsp;{{ data.value.text }}</li>
          <li>
            <strong>Advertiser/Event name:</strong>&nbsp;{{
              data.value.aEventName
            }}
          </li>
          <li>
            <strong>Ad redeem address:</strong>
            {{ data.value.aRedeemAddress.street }}
            {{ data.value.aRedeemAddress.city }}
            {{ data.value.aRedeemAddress.zip }}
            {{ data.value.aRedeemAddress.country }}
          </li>
        </ul>
      </template>
    </b-table>
  </div>
</template>

<script>
import API from '@/api';
export default {
  name: 'Advertisments',
  data() {
    return {
      advertisings: [],
      fields: [
        '_id',
        'name',
        'email',
        'price',
        'menRecipientsNumber',
        'womenRecipientsNumber',
        'advertisment',
        'pushSent',
        'updatedAt'
      ]
    };
  },
  created() {
    API.post(`admin/advertising/list`, this.$data).then(res => {
      if (res.status === 'ok') {
        console.log(res.data.advertisings);
        this.advertisings = res.data.advertisings;
      }
    });
  }
};
</script>

<style scoped>
table {
  font-size: 12px;
}
</style>
